<loading [isFixed]="true" [isAbsolute]="false" [isLoading]="isLoading" [isFullSize]="true"></loading>
<!-- <div class="row" *ngIf="columnHeader.hasOwnProperty('Actions')"></div> -->
<div class="header-actions">
  <div class="col-10 header-left-section">
    <div class="search-pill">
      <input class="search-pill-input" [(ngModel)]="filtroInput" placeholder="Filtro" (keyup)="applyFilter($event)" />
      <mat-icon aria-hidden="false" class="btn-buscar" (click)="applyFilter()">search</mat-icon>
      <mat-icon aria-hidden="false" class="btn-limpiar" (click)="refreshFilter()">cancel</mat-icon>
    </div>
    <div class="header-actions-buttons">
      <div class="status-toggle" *ngIf="hasInactives">
        <button class="toggle-btn toggle-left" [class.toggle-selected]="!isInactive" (click)="isInactive && GetInactives()">Activos</button>
        <button class="toggle-btn toggle-right" [class.toggle-selected]="isInactive" (click)="!isInactive && GetInactives()">Inactivos</button>
      </div>
    </div>
  </div>
  <div class="AddButton" *ngIf="columnHeader.hasOwnProperty('Actions') && hasAddable">
    <a [routerLink]="routeAdd">
      <button class="form-control btn-primary btn-agregar" mat-button><mat-icon>add</mat-icon> Agregar</button>
    </a>
  </div>
</div>

<div class="table-section">
  <table #miTabla mat-table [dataSource]="mainDataSource" matSort class="mat-elevation-z8">
    <ng-container
      [matColumnDef]="dataKeys"
      *ngFor="let dataKeys of objectKeys(columnHeader)"
    >
    
      <ng-container [ngSwitch]="dataKeys">
        <ng-container *ngSwitchDefault>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div style="display: flex; flex-direction: column;">
              <div style="display: flex; flex-direction: row; align-items: center;">

                <div>
                  {{ columnHeader[dataKeys].displayName }}
                </div>
                
                <button matMenuTriggerRestoreFocus="false" *ngIf="columnHeader[dataKeys].filterable" mat-icon-button [matMenuTriggerFor]="filterMenu" (click)="setCurrentColumn(dataKeys)">
                  <!-- <mat-icon>filter_list</mat-icon> -->
                  <mat-icon *ngIf="!columnHeader[dataKeys].activeFilter" >filter_alt_on</mat-icon>
                  <mat-icon *ngIf="columnHeader[dataKeys].activeFilter" >filter_alt_off</mat-icon>
                </button>
  
              </div>

              <div>
                <span *ngIf="columnHeader[dataKeys].activeFilter">({{ columnHeader[dataKeys].activeFilter }})</span>
              </div>

            </div>
          </th>
          <td  mat-cell *matCellDef="let element; let i = index">
            <div >{{ element[dataKeys] }}</div>
          </td>
        </ng-container>
  
        <ng-container *ngSwitchCase="'Icon'">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element; let i = index" >
            <mat-icon>{{ element[dataKeys] }}</mat-icon>
          </td>
        </ng-container>
  
        <ng-container *ngSwitchCase="'Status'">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div style="display: flex; flex-direction: column;">
              <div style="display: flex; flex-direction: row; align-items: center;">

                <div>
                  {{ columnHeader[dataKeys].displayName }}
                </div>
                
                <button matMenuTriggerRestoreFocus="false" *ngIf="columnHeader[dataKeys].filterable" mat-icon-button [matMenuTriggerFor]="filterMenu" (click)="setCurrentColumn(dataKeys)">
                  <!-- <mat-icon>filter_list</mat-icon> -->
                  <mat-icon *ngIf="!columnHeader[dataKeys].activeFilter" >filter_alt_on</mat-icon>
                  <mat-icon *ngIf="columnHeader[dataKeys].activeFilter" >filter_alt_off</mat-icon>
                </button>
  
              </div>

              <div>
                <span *ngIf="columnHeader[dataKeys].activeFilter">({{ columnHeader[dataKeys].activeFilter }})</span>
              </div>
              
            </div>
          </th>
          <td  mat-cell *matCellDef="let element; let i = index">
            <div [ngClass]="{'active-status': element[dataKeys] == 'Activo'}">{{ element[dataKeys] }}</div>
          </td>
        </ng-container>
  
        <ng-container *ngSwitchCase="'Actions'">
          <th mat-header-cell *matHeaderCellDef>{{ columnHeader[dataKeys].displayName }}</th>
          <td mat-cell *matCellDef="let row" >
            <div class="actions">
              <mat-icon class="btn-edit" (click)="handleClick(row, 'edit')" *ngIf="row.IsEditable">edit</mat-icon>
              <mat-icon class="btn-idelete" (click)="handleClick(row, 'delete')" *ngIf="row.IsDeletable ">delete</mat-icon>
            </div>
          </td>
        </ng-container>
     
        <!-- detalles de user log -->
        <ng-container *ngSwitchCase="'DetailList'">
          <th mat-header-cell *matHeaderCellDef>{{ columnHeader[dataKeys].displayName }}</th>
          <td mat-cell *matCellDef="let row" >
            <div class="actions">
              <mat-icon class="btn-edit" (click)="listPopUp(row)">event_note</mat-icon>
            </div>
          </td>
        </ng-container>

        <!-- detalles de alarmas -->
        <ng-container *ngSwitchCase="'AlarmDetails'">
          <th mat-header-cell *matHeaderCellDef>{{ columnHeader[dataKeys].displayName }}</th>
          <td mat-cell *matCellDef="let row" >
            <div *ngIf="row.IdAlarm != 0 " class="actions">
              <mat-icon class="btn-edit" (click)="alarmDetailPopUp(row)">event_note</mat-icon>
            </div>
            <div *ngIf="row.IdAlarm == 0" class="actions">
              <label for="">sin alarma</label>
            </div>
          </td>
        </ng-container>

        <ng-container *ngSwitchCase="'AlarmLogDetails'">
          <th mat-header-cell *matHeaderCellDef>{{ columnHeader[dataKeys].displayName }}</th>
          <td mat-cell *matCellDef="let row" >
            <div *ngIf="row.IdAlarm != 0 " class="actions">
              <mat-icon class="btn-edit" (click)="alarmLogDetailPopUp(row)">event_note</mat-icon>
            </div>
            <div *ngIf="row.IdAlarm == 0" class="actions">
              <label for="">sin Log</label>
            </div>
          </td>
        </ng-container>
      </ng-container>
    </ng-container>
  
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow >
      <td class="mat-cell" colspan="4">No se encontraron datos</td>
    </tr>
  
    <tr mat-header-row *matHeaderRowDef="objectKeys(columnHeader)"></tr>
    <tr mat-row *matRowDef="let row; columns: objectKeys(columnHeader)" 
                [ngClass]="{'alarmed-row': row['statusAlarm'] === 'Alarmed', 'standby-row': row['statusAlarm'] === 'StandBy', 'inactiveUser': isInactive}"></tr>
  </table>
</div>

<mat-paginator 
  [pageSize]="10"
  [length]="mainTotalCount"
  (page)="nextPage($event)"
></mat-paginator>

<mat-menu #filterMenu="matMenu">
  <!-- Campo de entrada para filtrar las opciones -->
  <div style="padding: 3px;" (click)="$event.stopPropagation()">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Buscar</mat-label>
      <input matInput [(ngModel)]="filterSearchText" placeholder="Escribe para filtrar"  />
    </mat-form-field>
  </div>

  <!-- opcion de limpiado -->
  <button mat-menu-item (click)="clearColumnFilter()">---Limpiar---</button>

  <!-- se usa un pipe con la cadena del buscador para traer el array dinámico  -->
  <ng-container *ngFor="let option of (filterOptions[currentColumn] | filterArray: filterSearchText)">
    <button mat-menu-item (click)="applyColumnFilter(option)">{{ option }}</button>
  </ng-container>
</mat-menu>